import { Injectable } from '@angular/core';
import { ChatMessagesService } from 'common/chat-messages/chat-messages.service';
import { ChatMessage } from 'common/xislivechat/models/chat-message';
import { DynamicQueryStoreObservableFactory } from 'common/dynamicquery/dynamic-query-store-observable';

@Injectable({
  providedIn: 'root'
})
export class ChatMessagesStoreFactory {
  constructor(private _chatMessageService: ChatMessagesService,
              private DynamicQueryStoreObservableFactory: DynamicQueryStoreObservableFactory) {
  }

  public create(chatId) {
    if (!chatId) {
      throw new Error('Missing chatId');
    }

    const activeChats = this._chatMessageService.observePastMessagesByChatId(chatId);
    return this.DynamicQueryStoreObservableFactory.create(activeChats, ChatMessage.comparator);
  }
}
